<template>
  <div class="page new-ticket">
    <div v-if="isMobile || true" class="noheader">
      <div class="flexcentered bigger">
        Fake payment page
      </div>
      <button @click="close">Chiudi pagamento</button>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'

export default {
  name: 'FakePayment',
  mixins: [ page ],
  methods: {
    close () {
      window.close()
    }
  },
  mounted () {
    setTimeout(() => {
      window.closeme = true
    }, 3000)
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';
</style>
